import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { RoutableRichText } from '../../react/RoutableRichText';
import { RoutableLink } from '../../react/RoutableLink';
import css from './index.module.scss';

const LinkListing = ({ fields }) => (
  <section className={`${css.container} linkList`}>
    <div className={`${css.containerInner} linkList-inner single-col-inner`}>
      <Text field={fields?.heading} tag='h3' className={`${css.heading} linkList-heading`} />
      <ul className={`${css.list} linkList-list`}>
        {
          fields?.children?.map((link, index) =>
            <li key={index} className={'linkList-listItem'}>
              <RoutableLink field={link.fields.link} className={'linkList-link'} data-chevron={true}>
                <Text field={link.fields.linkText} />
              </RoutableLink>
              <RoutableRichText field={link.fields.description} className={'linkList-description'} />
            </li>
          )
        }
      </ul>
    </div>
  </section>
);

export default LinkListing;